<template>
  <v-dialog scrollable persistent content-class="custom-dialog" ref="dlgKelas" v-model="dialog" retain-focus max-width="700">
    <template v-slot:activator="{}"></template>
    <v-card v-if="st == 1">
      <v-card-title class="primary title white--text " style="word-break: break-word;">
        <div class="ml-5">{{ model == "ubah" ? "Pilih Mata Pelajaran" : "Pendaftaran Guru Belajar & Berbagi Seri " + current_instansi.nama }}</div>
      </v-card-title>
      <v-card-text class="pt-5 mb-0 pb-0">
        <v-form data-vv-scope="form-biodata" lazy-validation>
          <v-row column wrap class="ma-2">
            <v-col cols="12" sm="12" md="12" lg="12" class="my-0 py-0">
              <v-text-field
                outlined
                dense
                autocomplete="false"
                name="NIK"
                placeholder="NIK maksimal 16 digit"
                label="NIK"
                v-model="akun.ktp_nik"
                persistent-hint
                data-vv-name="nik"
                data-vv-as="NIK"
                v-validate="'required|numeric|min:16|max:16'"
                :error-messages="errors.collect('form-biodata.nik')"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12" class="my-0 py-0">
              <v-text-field
                outlined
                dense
                autocomplete="false"
                name="Nama Sesuai KTP"
                placeholder="Isikan Nama sesuai KTP"
                label="Nama sesuai KTP"
                v-model="akun.ktp_nama"
                persistent-hint
                data-vv-name="nama"
                data-vv-as="Nama sesuai KTP"
                v-validate="'required'"
                :error-messages="errors.collect('form-biodata.nama')"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12" class="my-0 py-0">
              <span>Jenis Kelamin</span>
              <v-radio-group v-model="akun.ktp_kelamin" row class="mt-0 mb-2">
                <v-radio v-for="kelamin in itemKelamins" :key="kelamin.index" :label="kelamin == 'L' ? 'Laki-Laki' : 'Perempuan'" :value="kelamin"></v-radio>
              </v-radio-group>
            </v-col>
            <v-col cols="12" sm="12" md="6" lg="6" class="my-0 py-0">
              <v-text-field
                outlined
                dense
                autocomplete="false"
                name="Tempat Lahir"
                placeholder="Isikan Tempat Lahir"
                label="Tempat Lahir"
                v-model="akun.ktp_tempat_lahir"
                persistent-hint
                data-vv-name="tempat_lahir"
                data-vv-as="Tempat Lahir"
                v-validate="'required'"
                :error-messages="errors.collect('form-biodata.tempat_lahir')"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="6" lg="6" class="my-0 py-0">
              <m-datepicker
                dense
                outlined
                placeholder="Isikan Tanggal Lahir"
                label="Tanggal Lahir"
                v-model="akun.ktp_tanggal_lahir"
                :value="akun.ktp_tanggal_lahir"
                :max="max_tanggal_lahir"
                hint="Tanggal Lahir"
                data-vv-name="tgl_lahir"
                data-vv-as="Tanggal Lahir"
                v-validate="'required'"
                :error-messages="errors.collect('form-biodata.tgl_lahir')"
              ></m-datepicker>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions class="mx-6 mt-0 pt-0 mb-2">
        <v-row no-gutters>
          <v-col cols="12">
            <v-checkbox v-model="setujuBiodata" class="mx-2" dense color="info" name="setuju" label="" data-vv-name="setuju" data-vv-as="Persetujuan">
              <template v-slot:label>
                <div class="body-2 info--text">Dengan ini saya menyatakan bahwa data yang saya cantumkan sesuai dengan data KTP yang saya miliki.</div>
              </template>
            </v-checkbox>
          </v-col>
          <v-col cols="12" align="right">
            <m-button
              class="mx-1"
              color="grey"
              outlined
              :small="$vuetify.breakpoint.smAndDown ? true : false"
              textButton="Batal"
              icon=""
              action="tutup"
              @tutup="dialog = false"
            ></m-button
            ><m-button depressed :disabled="!setujuBiodata" color="primary" icon="mdi-save" textButton="Simpan" action="simpanBiodata" @simpanBiodata="simpanBiodata"></m-button>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>

    <v-card text class="rounded-lg mb-0 pb-0" v-else>
      <v-card-title class="primary title white--text" style="word-break: break-word;"> Pilih salah satu mata pelajaran yang ingin diikuti</v-card-title>
      <div class="black--text body-1 ml-8 mr-5 mt-4 mb-0">
        Pastikan mapel yang dipilih sesuai dan atau linear dengan prodi kelulusan D4/S1 terakhir.
        <m-alert show class="my-2">
          <template>
            <span class="black--text">Daftar mata pelajaran yang bisa dipilih di Seri PPPK Program keahlian Kejuruan mengacu pada dokumen berikut: &nbsp;</span><br />
            <a href="https://ayogurubelajar.kemdikbud.go.id/wp-content/uploads/2021/07/SALINAN-Kepmen-Program-SMK-Pusat-Keunggulan-jdih.kemdikbud.go_.id_.pdf" target="_blank"
              >Kepmen Program SMK Pusat</a
            >
          </template>
        </m-alert>
      </div>
      <v-card-text class="mt-3 mb-0 pb-0">
        <v-form autocomplete="false" @submit.prevent data-vv-scope="form" lazy-validation>
          <v-row>
            <v-col cols="12" class="mb-0 pb-0">
              <v-radio-group ref="radio" v-model="jenisMapel" row>
                <v-radio :disabled="disableJenisMapel" v-for="option in pilihanJenisMapel" :key="option.key" :label="option.key" :value="option.value"></v-radio> </v-radio-group
            ></v-col>
            <v-col cols="12" class="mb-0 pb-0" v-if="jenisMapel == 0">
              <v-autocomplete
                class="mx-2"
                outlined
                v-model="kelas"
                :key="Math.random()"
                :items="items"
                item-text="nama"
                item-value="id"
                return-object
                placeholder="Pilih Mata Pelajaran"
                data-vv-name="mapel"
                data-vv-as="Mata Pelajaran"
                label="Pilh Mata Pelajaran"
              >
                <template slot="selection" slot-scope="data">
                  <span class="font-weight-bold caption">{{ data.item.nama }}</span>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="12" class="mb-0 pb-0" v-else>
              <v-autocomplete
                class="mx-2"
                outlined
                v-model="kelas"
                :key="Math.random()"
                :items="itemKejuruans"
                item-text="nama"
                item-value="id"
                return-object
                placeholder="Pilih Program Keahlian Kejuruan"
                data-vv-name="mapel"
                data-vv-as="Program Keahlian Kejuruan"
                label="Pilh Program Keahlian Kejuruan"
              >
                <template slot="selection" slot-scope="data">
                  <span class="font-weight-bold caption">{{ data.item.nama }}</span>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
        </v-form>
        <div class="text-left black--text mx-2">
          <span class="font-weight-bold">Syarat dan Ketentuan</span>
          <ol>
            <li class="mt-1">
              Program ini diperuntukkan bagi peserta yang akan mengikuti seleksi guru ASN PPPK. Program ini hanya memfasilitasi peserta untuk belajar mandiri dalam mempersiapkan
              diri mengikuti seleksi dimaksud dan <span class="font-weight-bold red--text">tidak menjamin kelulusan peserta menjadi guru ASN PPPK</span>. Kementerian yang berwenang
              menentukan kelulusan adalah Kementerian Pendayagunaan Aparatur Negara dan Reformasi Birokrasi (PAN RB).
            </li>
            <li class="mt-1">
              Peserta wajib menuntaskan Fasilitasi Pembelajaran selama 7 (tujuh) hari sejak pemilihan mata pelajaran. Jika tidak tuntas maka diberikan kesempatan 1 (satu) kali
              untuk mengulang atau mengganti mata pelajaran.
            </li>
            <li class="mt-1">
              Peserta yang sudah pernah mengikuti seri <b>PPPK Umum</b> dapat mengikuti lagi pada <b>PPPK Program Keahlian Kejuruan</b> dengan hanya memiliki kesempatan memilih
              <b>1x pilih mapel Program Keahlian Kejuruan</b>, sedangkan untuk peserta yang belum mengikuti seri PPPK Umum mendapatkan kesempatan
              <b>2x memilih mapel Program Keahlian Kejuruan</b>
            </li>
            <li class="mt-1">
              Sanggup melaksanakan Try-Out sesuai jadwal yang ditetapkan oleh sistem. Bila masih tersedia jadwal Try-Out dan kuota Try-Out belum terpenuhi, peserta dapat memiliki
              kesempatan 1 (satu) kali Try Out Ulang
            </li>
          </ol>
        </div>
      </v-card-text>
      <v-card-actions class="pb-4 py-0 mx-2">
        <v-row no-gutters>
          <v-col cols="12">
            <v-checkbox
              v-model="setuju"
              class="mx-2"
              dense
              color="info"
              name="setuju"
              label=""
              data-vv-name="setuju"
              data-vv-as="Persetujuan"
              v-validate="'required'"
              :error-messages="errors.collect('form.setuju')"
            >
              <template v-slot:label>
                <div class="body-2 info--text">
                  Dengan ini saya menyetujui syarat dan ketentuan yang berlaku dalam mengikuti Guru Belajar dan Berbagi Seri {{ current_instansi.nama }} ini.
                </div>
              </template>
            </v-checkbox>
          </v-col>
          <v-col cols="12" align="right">
            <m-button
              class="mx-1"
              color="grey"
              outlined
              :small="$vuetify.breakpoint.smAndDown ? true : false"
              textButton="Batal"
              icon=""
              action="tutup"
              @tutup="dialog = false"
            ></m-button>
            <m-button
              class="mx-1"
              :disabled="!setuju"
              :small="$vuetify.breakpoint.smAndDown ? true : false"
              :textButton="model == 'ubah' ? 'Pilih Mapel' : 'Daftar'"
              icon=""
              action="pilihKelas"
              @pilihKelas="daftarKelas()"
            ></m-button>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      st: 1,
      disableJenisMapel: false,
      jenisMapel: 1,
      pilihanJenisMapel: [
        { key: "Umum", value: 0 },
        { key: "Kejuruan", value: 1 }
      ],
      row: null,
      jenis: null,
      edit: false,
      akun: {
        ktp_nik: "",
        ktp_nama: "",
        ktp_kelamin: "L",
        ktp_tempat_lahir: "",
        ktp_tanggal_lahir: "2004-01-01"
      },
      max_tanggal_lahir: "2004-12-31",
      itemKelamins: ["L", "P"],
      dialog: false,
      resolve: null,
      reject: null,
      kelas: null,
      items: [],
      itemKejuruans: [],
      setuju: false,
      setujuBiodata: false,
      model: null
    };
  },
  methods: {
    // eslint-disable-next-line
    // model pilih jadwal atau mode pilih jadwal ulang
    open(model, obj) {
      if (this.current_user && !this.current_user.is_daftar_p3k_umum && this.current_user.is_daftar_p3k_kejuruan) {
        this.jenisMapel = 1;
        this.loadMapelKejuruan();
        this.loadMapel();
        // this.disableJenisMapel = true;
      }
      this.st = model == "ubah" || this.current_user.is_nik_verified ? 2 : 1;
      if (this.current_user.ktp_nik) {
        var akun = {
          ktp_nama: this.current_user.ktp_nama,
          ktp_tempat_lahir: this.current_user.ktp_tempat_lahir,
          ktp_tanggal_lahir: this.current_user.ktp_tanggal_lahir,
          ktp_kelamin: this.current_user.ktp_kelamin,
          ktp_nik: this.current_user.ktp_nik
        };
        this.akun = { ...akun };
      }
      this.setujuBiodata = false;
      this.setuju = false;
      this.jenis = obj;
      this.model = model;
      return this.loadMapel().then(() => {
        return new Promise((resolve, reject) => {
          this.resolve = resolve;
          this.reject = reject;
          this.dialog = true;
        });
      });
    },
    // eslint-disable-next-line
    loadMapel() {
      return this.$store
        .dispatch("kelas/getMapel", this.instansi_id)
        .then(res => {
          this.items = res;
        })
        .catch(e => e);
    }, // eslint-disable-next-line
    loadMapelKejuruan() {
      return this.$store
        .dispatch("kelas/getMapelKejuruan", this.instansi_id)
        .then(res => {
          res.forEach(submapel => {
            this.itemKejuruans.push(submapel.mapel);
          });
        })
        .catch(e => e);
    },

    simpanBiodata() {
      this.$validator
        .validateAll("form-biodata")
        .then(res => {
          if (!res) return Promise.reject();
          return res;
        })
        .then(() => {
          return this.$store.dispatch("user/biodata", this.akun).then(res => {
            if (res.error) {
              this.st = 1;
            } else {
              this.$success("Data berhasil disimpan, silakan dilanjutkan dengan memilih mata pelajaran");
              this.st = 2;
            }
          });
        });
    },

    daftarKelas() {
      this.$validator
        .validateAll("form")
        .then(res => {
          if (!res) return Promise.reject();
          return res;
        })
        .then(() => {
          if (!this.kelas) {
            this.$error("Pilih mata pelajaran yang ingin diikuti");
          } else {
            var objKelas = {
              kelas_id: this.kelas.id
            };
            // api pindah jadwal
            if (this.model == "ubah") {
              this.$store.commit("main/pStart");
              return this.$store
                .dispatch("kelas/enrollPppk", { model: "ubah", obj: objKelas, params: { mapel_id: this.kelas.id } })
                .then(res => {
                  this.$store.commit("main/pEnd");
                  this.$info("Anda berhasil mendaftar di Mata Pelajaran " + this.kelas.nama);
                  this.dialog = false;
                  this.edit = false;
                  return this.resolve(res);
                })
                .catch(() => {
                  this.$store.commit("main/pEnd");
                });
            } else {
              this.$store.commit("main/pStart");

              return this.$store
                .dispatch("kelas/enrollPppk", { model: "pilih", obj: objKelas, params: { mapel_id: this.kelas.id } })
                .then(res => {
                  this.$store.commit("main/pEnd");
                  this.$info("Anda berhasil mendaftar di Mata Pelajaran " + this.kelas.nama);
                  this.dialog = false;
                  this.edit = false;
                  return this.resolve(res);
                })
                .catch(() => {
                  this.$store.commit("main/pEnd");
                });
            }
          }
        });
    }
  },
  watch: {
    dialog(n) {
      if (!n && this.reject) {
        this.reject(null);
      }
    }
  }
};
</script>
<style>
.stepper-scrollable-content {
  overflow: auto;
  max-height: calc(100% - 71px);
}
.custom-dialog {
  -webkit-box-shadow: 0px 0px 2px 2px rgb(231, 230, 230);
}
</style>
